var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"control-img"},[_c('img',{attrs:{"src":_vm.direction == 'portrait'
          ? require('../../assets/image/magnify-icons.png')
          : require('../../assets/image/shrink-icons.png'),"alt":""},on:{"click":_vm.handleChange}})]),_c('div'),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-counter"},[_c('div',{attrs:{"id":"flowLine"}})])
}]

export { render, staticRenderFns }